import { DOMAIN } from "../constants";

export const clsPrefix = 'cap-media-generation-bot';

export const AI_MEDIA_GENERATION = `${DOMAIN}/arya/api/v1/ask-aira-service/image_gen/txt2img`;

export const MEDIA_GENERATION_REQUEST = "MEDIA_GENERATION_REQUEST";
export const MEDIA_GENERATION_SUCCESS = "MEDIA_GENERATION_SUCCESS";
export const MEDIA_GENERATION_FAILURE = "MEDIA_GENERATION_FAILURE";

export const tips = [
    "Provide a detailed and specific prompt with clear language for the desired image",
    "Use adjectives to convey mood, style, and elements",
    "Mention the desired colors and lighting for the desired color palette"
];
export const IMAGE = 'Image';
export const VIDEO = 'Video';
export const REQUEST = 'REQUEST';

export const MEDIA_GENERATION_REDUCER_DOMAIN = 'MEDIA_GENERATION';